import { createContext } from 'react';
import { NotificationManager } from '../notification/classes/NotificationManager/NotificationManager';

export const NotificationManagerContext = createContext({
  notificationManager: new NotificationManager()
});
